import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '@config/products.config';

export const EXCLUDED_PROPERTIES = [
  'travelDurationType'
];

export const PRODUCT_PACKAGE = {
  SUPER: 'SUPER',
  KASKO: 'KASKO',
  FIRE_AND_THEFT: 'FIRE_AND_THEFT',
  FIRE_AND_THEFT_STANDALONE: 'FIRE_AND_THEFT_STANDALONE'
};

export const PROPERTIES_FORM_NAME = 'properties';
export const DATE_INPUT_ID_LABEL = 'date-input_';

export const CLEAR_SELECT_INPUT_LABEL = 'intClearSelectInput';

export const DYNAMIC_PROPERTYES = {
  CONTINUED_INSURANCE_B2B_PROPERTY: {
    name: 'continuedInsuranceB2B', key: 'CONTINUED_INSURANCE_B2B', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  HEALTH_SENIORITY_DATE_PROPERTY: {
    name: 'healthSeniorityDate', key: 'HEALTH_SENIORITY_DATE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.DATE,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      dateView: 'month'
    }
  },
  RENTAL_PERIOD_PROPERTY: {
    name: 'rentalPeriod', key: 'RENTAL_PERIOD', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.RENTAL_PERIOD.1_4_WEEKS', value: '1_4_WEEKS' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.RENTAL_PERIOD.1_6_MONTH', value: '1_6_MONTH' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.RENTAL_PERIOD.6_12_MONTH', value: '6_12_MONTH' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.RENTAL_PERIOD.YEAR_LONG', value: 'YEAR_LONG' },
      ]
    }
  },
  MOISURE_OR_WATER_DAMAGE_PROPERTY: {
    name: 'moistureOrWaterDamage', key: 'MOISURE_OR_WATER_DAMAGE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  DEFICIENCIES_OR_ERROR_OR_DAMAGES_PROPERTY: {
    name: 'deficienciesOrErrorsOrDamages', key: 'DEFICIENCIES_OR_ERROR_OR_DAMAGES', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  INSURANCE_AMOUNT_OF_DEATH_PROPERTY: {
    name: 'wtcAccidentSumInsuredDeath', key: 'ACCIDENT_SUM_INSURED_DEATH', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_HIGHT_SPEED_CERTIFICATE_PROPERTY: {
    name: 'wtcBoatHighSpeedCertificate', key: 'BOAT_HIGHT_SPEED_CERTIFICATE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  LICENCE_NUMBER_TRAILER_HOME_PROPERTY: {
    name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
    pattern: /[a-zA-Z]{2}\d{5}/,
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['']
  },
  LISING_PROPERTY: {
    name: 'vehicleLeasingCompany', key: 'VEHICLE_LEASING_COMPANY', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  VEHICLE_LEASING_PROPERTY: {
    name: 'vehicleLeasing', key: 'VEHICLE_LEASING', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_MOTOR_INCURANCE_PROPERTY: {
    name: 'wtcBoatMotorInsurance', key: 'BOAT_MOTOR_INCURANCE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_MOTOR_INCURANCE_PROPERTY_KOLIBRI: {
    name: 'wtcBoatMotorInsurance', key: 'BOAT_MOTOR_INCURANCE_KOLIBRI', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  SERIAL_NUMBER_PROPERTY: {
    name: 'wtcSerialNumber', key: 'WTC_SERIAL_NUMBER', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['']
  },
  ANIMAL_ID_PROPERTY: {
    name: 'animalId', key: 'ANIMAL_ID', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.TEL,
    validator: ['', [
      Validators.required
    ]]
  },
  ANIMAL_USAGE_AREA_PROPERTY: {
    name: 'animalUsageArea', key: 'ANIMAL_USAGE_AREA', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_USAGE_AREA.FAMILY_DOG', value: 'FAMILY_DOG' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_USAGE_AREA.HUNTING_DOG', value: 'HUNTING_DOG' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_USAGE_AREA.HERDING_DOG', value: 'HERDING_DOG' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.ANIMAL_USAGE_AREA.SERVICE_DOG', value: 'SERVICE_DOG' }
      ]
    }
  },
  DRIVER_BIRTH_YEAR_PROPERTY: {
    name: 'driverBirthYear', key: 'DRIVER_BIRTH_YEAR_SNOWMOBILE', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.DATE,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      dateView: 'multi-years'
    }
  },
  SECURE_MARK_NUMBER_PROPERTY: {
    name: 'wtcBoatSecuremarkNumber', key: 'BOAT_SECUREMARK_NUMBER', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['']
  },
  SECURE_MARK_BOAT_PROPERTY: {
    name: 'secureMarkBoat', key: 'BOAT_SECUREMARK', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  SECURE_MARK_BOAT_ENGINE_PROPERTY: {
    name: 'secureMarkEngine', key: 'BOAT_SECUREMARK_ENGINE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_MOTOR_MARK_PROPERTY: {
    name: 'wtcBoatMotorMark', key: 'BOAT_MOTOR_MARK', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_TOTAL_HP_PROPERTY: {
    name: 'wtcBoatTotalNk', key: 'BOAT_TOTAL_NK', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_DAMAGE_PROPERTY: {
    name: 'wtcBoatDamage', key: 'BOAT_DAMAGE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.BOOLEAN,
    validator: ['', [
      Validators.required
    ]]
  },
  BOAT_MOTOR_AGE_PROPERTY:  {
    name: 'wtcBoatMotorAge', key: 'BOAT_MOTOR_AGE', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.DATE,
    isWtcBoatBoatDamageCheck: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      dateView: 'multi-years'
    }
  },
  VEHICLE_MODEL: {
    name: 'vehicleModel', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    disabled: true,
    validator: ['']
  },
  VEHICLE_BRAND: {
    name: 'vehicleBrand', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    disabled: true,
    validator: ['']
  },
  OFV_VARIANTS_LIST_PROPERTY: {
    name: 'ofvVariantId', key: 'OFV_VARIANT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isHugeSelectContainer: true,
    showOfvManualTable: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  OFV_VARIANTS_LIST_PROPERTY_WITHOUT_MANUAL_TABLE: {
    name: 'ofvVariantId', key: 'OFV_VARIANT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isHugeSelectContainer: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  WTC_RENTAL_NUMBER_APARTMENTS_PROPERTY: {
    name: 'wtcRentalNumberApartments', key: 'WTC_RENTAL_NUMBER_APARTMENTS', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_RENTAL_NUMBER_APARTMENTS.0', value: 0 },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_RENTAL_NUMBER_APARTMENTS.1', value: 1 },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_RENTAL_NUMBER_APARTMENTS.2', value: 2 },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_RENTAL_NUMBER_APARTMENTS.3', value: 3 }
      ]
    }
  },
  WTC_MONTHLY_RENTAL_INCOME_PROPERTY: {
    name: 'wtcMonthlyRentalIncome', key: 'WTC_MONTHLY_RENTAL_INCOME', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.0', value: '0' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.10000', value: '>10000' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.15000', value: '10001-15000' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.20000', value: '15001-20000' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.30000', value: '20001-30000' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.WTC_MONTHLY_RENTAL_INCOME.50000', value: '30001-50000' },
      ]
    }
  },
  OFV_CAR_BRANDS_LIST_PROPERTY: {
    name: 'ofvBrandId', key: 'CAR_BRANDS', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isOfvBrandId: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  OBJECT_CATEGORY_TYPE_PROPERTY: {
    name: 'objectCategoryType', key: 'OBJECT_CATEGORY_TYPE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    },
    customValueConfig: {
      PHOTO_TV: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PHOTO_VIDEOCAMERA', value: 'PHOTO_VIDEOCAMERA' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.TV', value: 'TV' }
          ]
        }
      },
      ELECTRONICS: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PC', value: 'PC' }
          ]
        }
      },
      JEWLERY: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.CLOCK', value: 'CLOCK' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.POCKET_WATCH', value: 'POCKET_WATCH' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SILVER', value: 'SILVER' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.JEWLERY', value: 'JEWLERY' },
          ]
        }
      },
      MUSIC: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SPEAKER', value: 'SPEAKER' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.INSTRUMENT', value: 'INSTRUMENT' },
          ]
        }
      },
      HOBBY_EQUIPMENT: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BINOCULARS', value: 'BINOCULARS' }
          ]
        }
      },
      ART: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PICTURE_ART', value: 'PICTURE_ART' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GLASS_ART', value: 'GLASS_ART' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SCULPTURE_OF_METAL', value: 'SCULPTURE_OF_METAL' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SCULPTURE_OF_STONE', value: 'SCULPTURE_OF_STONE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.TEXTILE_ART', value: 'TEXTILE_ART' }
          ]
        }
      },
      CLOTHES: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BUNAD', value: 'BUNAD' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BUNAD_WITH_BUNAD_SILVER', value: 'BUNAD_WITH_BUNAD_SILVER' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FUR', value: 'FUR' },
          ]
        }
      },
      SPORTS_EQUIPMENT: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.BICYCLE', value: 'BICYCLE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.GOLF_EQUIPMENT', value: 'GOLF_EQUIPMENT' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.RIDING_SADDLE', value: 'RIDING_SADDLE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.FISHING_EQUIPMENT', value: 'FISHING_EQUIPMENT' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.ARMS', value: 'ARMS' }
          ]
        }
      },
      SPORT_SPECIAL: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.DIVING_EQUIPMENT', value: 'DIVING_EQUIPMENT' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.PARACHUTE', value: 'PARACHUTE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HANG_OR_PARAGLIDER', value: 'HANG_OR_PARAGLIDER' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_ALPINE',
               value: 'SKIS_AND_BOOTS_FOR_ALPINE' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_CROSS_COUNTRY_SKIING', value: 'SKIS_AND_BOOTS_FOR_CROSS_COUNTRY_SKIING' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKIS_AND_BOOTS_FOR_TELEMARK', value: 'SKIS_AND_BOOTS_FOR_TELEMARK' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SNOWBOARD', value: 'SNOWBOARD' },
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.SKATEBOARD', value: 'SKATEBOARD' }
          ]
        }
      },
      OTHER: {
        settings: {
          list: [
            { key: 'PROPERTIES_FORM.SELECT_LIST.OBJECT_CATEGORY_VALUABLES_TYPE.HEARING_AID', value: 'HEARING_AID' },
          ]
        }
      },
    }
  },
  OFV_CAR_MODEL_LIST_PROPERTY: {
    name: 'ofvModelId', key: 'CAR_MODELS', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isOfvModelId: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  OFV_CAR_MODEL_REG_YEAR_LIST_PROPERTY: {
    name: 'vehicleRegistrationYear', key: 'REGISTRATION_YEAR', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isOfvModelRegYear: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  OFV_CAR_MODEL_YEAR_LIST_PROPERTY: {
    name: 'ofvYearModel', key: 'CAR_MODEL_YEARS', group: 'OBJECT_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    isOfvModelYear: true,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: []
    }
  },
  HOUSE_FIRST_RISK_SUM_INSURED: {
    name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    renderOnlyIfPresent: true,
    validator: ['', [
      Validators.required
    ]]
  },
  ELECTRIC_BICYCLE_VALUE_PROPERTY: {
    name: 'electricBicycleValue', key: 'ELECTRIC_BICYCLE_VALUE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.STRING,
    validator: ['', [
      Validators.required
    ]]
  },
  ELECTRIC_BICYCLE_COVERAGE_PACKAGE_PROPERTY: {
    name: 'electricBicycleCoveragePackage', key: 'ELECTRIC_BICYCLE_COVERAGE_PACKAGE', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.ELECTRIC_BICYCLE_COVERAGE_PACKAGE.STANDARD', value: 'STANDARD' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.ELECTRIC_BICYCLE_COVERAGE_PACKAGE.SUPER', value: 'SUPER' },
      ]
    }
  },
  TRAILER_EXTENDED_SUM_AMOUNT_PROPERTY: {
    name: 'contentsSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required,
      Validators.min(0),
      Validators.max(400000)
    ]]
  },
  TRAILER_EXTENDED_SUM_MOVABLES_PROPERTY: {
    name: 'productSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required,
      Validators.min(0),
      Validators.max(400000)
    ]]
  },
  MOBILE_HOME_EXTENDED_SUM_AMOUNT_PROPERTY: {
    name: 'contentsSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  MOBILE_HOME_EXTENDED_SUM_MOVABLES_PROPERTY: {
    name: 'productSumInsured', key: 'EXTENDED_SUM_AMOUNT', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    validator: ['', [
      Validators.required
    ]]
  },
  ANIMAL_DEATH_SUM_PROPERTY: {
    name: 'animalSIDeath', key: 'ANIMAL_DEATH_SUM', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.NUMBER,
    ANIMAL_DEATH_SUM_INSURED_RANGE: true,
    validator: ['', [
      Validators.required,
      Validators.pattern(/^\d+$/),
      Validators.min(0),
      Validators.max(50000)
    ]]
  },
  TRAVEL_NUMBER_OF_INSURED_PERSONS_PROPERTY: {
    name: 'travelNumberOfInsuredPersons', key: 'TRAVEL_NUMBER_OF_INSURED_PERSONS', group: 'INSURANCE_INFO',
    inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
    validator: ['', [
      Validators.required
    ]],
    settings: {
      list: [
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.2', value: '2' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.3', value: '3' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.4', value: '4' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.5', value: '5' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.6', value: '6' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.7', value: '7' },
        { key: 'PROPERTIES_FORM.SELECT_LIST.TRAVEL_NUMBER_OF_INSURED_PERSONS.8', value: '8' },
      ]
    }
  }
};
